import React from "react"
import ReactDOM from 'react-dom';
import axios from 'axios';
import { ReportClassPicker } from './forms/ReportClassPicker.jsx';
import { SelectableList } from './forms/dynamic/SelectableList.jsx';
import { AddRemoveButtons } from './shared/AddRemoveButtons.jsx';
import { ErrorMessage } from './shared/ErrorMessage.jsx';

class BulkReports extends React.Component {
  constructor(props) {
    super(props);

    var classList = this.props.classes.map((x) => x.display_name);
    this.state = {
      completeClassList: classList.slice(0),
      availableClassList: classList.slice(0),
      selectedClassList: [],
      selectedClass: classList[0],
      reports: {
        regByClass: true,
        resultsByClass: true,
        orderOfGo: true,
        howManyByClass: true,
        judgesCardHunter: true,
        judgesCardJumper: true
      }
    }
    this.selectClass = this.selectClass.bind(this);
    this.addClass = this.addClass.bind(this);
    this.removeClass = this.removeClass.bind(this);
    this.addAllClasses = this.addAllClasses.bind(this);
    this.removeAllClasses = this.removeAllClasses.bind(this);
    this.onCheckReport = this.onCheckReport.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onSubmitPortrait = this.onSubmitPortrait.bind(this);
    this.onSubmitLandscape = this.onSubmitLandscape.bind(this);
    this.submitAction = this.submitAction.bind(this);
  }

  selectClass(e) {
    this.setState({ selectedClass: e.target.value })
  }

  addClass() {
    var tempList1 = this.state.availableClassList;
    var tempList2 = this.state.selectedClassList;
    var index = tempList1.indexOf(this.state.selectedClass);
    if (index > -1) {
      tempList1.splice(index, 1);
      tempList2.push(this.state.selectedClass);
      this.setState({
        availableClassList: tempList1,
        selectedClassList: tempList2
      })
    }
  }

  removeClass() {
    var tempList1 = this.state.availableClassList;
    var tempList2 = this.state.selectedClassList;
    var index = tempList2.indexOf(this.state.selectedClass);
    if (index > -1) {
      tempList1.push(this.state.selectedClass);
      tempList2.splice(index, 1);
      this.setState({
        availableClassList: tempList1,
        selectedClassList: tempList2
      })
    }
  }

  addAllClasses() {
    this.setState({
      availableClassList: [],
      selectedClassList: this.state.completeClassList.slice(0)
    })
  }

  removeAllClasses() {
    this.setState({
      availableClassList: this.state.completeClassList.slice(0),
      selectedClassList: []
    })
  }

  onCheckReport(e) {
    var reports = this.state.reports;
    reports[e.target.id] = e.target.checked;
    this.setState({reports});
  }

  onBack() {
    window.location = `/individual_shows/${this.props.show_id}/reports`
  }

  onSubmitPortrait(e) {
    e.preventDefault();
    this.submitAction('portrait')
  }

  onSubmitLandscape(e) {
    e.preventDefault();
    this.submitAction('landscape')
  }

  submitAction(orientation) {
    axios.post('/api/v1/reports/bulk_print', {
      show_id: this.props.show_id,
      classes: this.state.selectedClassList,
      reports: this.state.reports,
      orientation: orientation
    })
      .then(response => window.open(response.data.url, '_blank'))
      .catch(error => console.log(error))
  }

  render () {
    return (
      <div className="wizard_wrapper">
        <h1>Print Reports for Selected Classes</h1>
        <div className="row">
          <div className="col-md-3">
            <h2>Available Classes</h2>
            <SelectableList
              list={this.state.availableClassList}
              selected={this.state.selectedClass}
              onClick={this.selectClass}
              onDoubleClick={this.addClass} />
          </div>
          <div className="col-md-2">
            <br/><br/><br/><br/><br/><br/><br/><br/><br/>
            <AddRemoveButtons
              onAdd={this.addClass}
              onRemove={this.removeClass}
              onAddAll={this.addAllClasses}
              onRemoveAll={this.removeAllClasses}
              disableAdd={this.state.selectedClassList.indexOf(this.state.selectedClass) > -1}
              disableRemove={this.state.availableClassList.indexOf(this.state.selectedClass) > -1} 
              btnSize={'btn-block'} />
          </div>
          <div className="col-md-3">
            <h2>Selected Classes</h2>
            <SelectableList
              list={this.state.selectedClassList}
              selected={this.state.selectedClass}
              onClick={this.selectClass}
              onDoubleClick={this.removeClass} />
          </div>
          <div className="col-md-2">
            <ReportClassPicker
              reports={this.state.reports}
              onCheck={this.onCheckReport}
              orientation={'Portrait'} />
          </div>
          <div className="col-md-2">
            <ReportClassPicker
              reports={this.state.reports}
              onCheck={this.onCheckReport}
              orientation={'Landscape'} />
          </div>
        </div>
        <div className="col-md-8">
          <button className="btn btn-success" onClick={this.onBack}>{`Back`}</button>
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary" onClick={this.onSubmitPortrait}>{`Print portrait reports`}</button>
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary" onClick={this.onSubmitLandscape}>{`Print landscape reports`}</button>
        </div>
        <div className="col-md-offset-8 col-md-4">
          <br/>
          <ErrorMessage message={`You need to allow Pop-ups on this website if the Print buttons don't work.`} />
        </div>
      </div>
    )
  }
}

export default BulkReports;
